module.exports = __webpack_public_path__ + "img/Foto_Lynn_.6e93a7ee.jpg";